import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {first, take} from "rxjs/operators";
import {SelfBillingForm} from "../interface/SelfBillingForm";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class SelfBillingFormService {
  public readonly selfBillingFormListSubject: ReplaySubject<CountedAndPaginated<SelfBillingForm>>
    = new ReplaySubject<CountedAndPaginated<SelfBillingForm>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {}

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/self-billing-form?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<SelfBillingForm>) => {
        this.selfBillingFormListSubject.next(result);
      });
  }

  public getSelfBillingFormListSubject(): ReplaySubject<CountedAndPaginated<SelfBillingForm>> {
    return this.selfBillingFormListSubject;
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/self-billing-form/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public delete(uuid: number): Observable<any> {
    return this.httpClient.delete(`/rest/crm/self-billing-form/${uuid}`)
      .pipe(first());
  }
}
